import constants from './constants';
const {
    SET_PRIOR_AUTH_BEGIN,
    SET_PRIOR_AUTH_SUCCESS,
    SET_PRIOR_AUTH_ERROR,
    SET_PRIOR_AUTH_CLEANUP
  } = constants;

  export const initialState = {
    priorAuth: null,
    loading: false,
    error: null,
};

export const PriorAuthReducer = (state = initialState, { type, payload }) => {
    
    switch (type) {
        case SET_PRIOR_AUTH_BEGIN:
                return {
                    ...state,
                    loading: true,
                    error: null
                };
    
        case SET_PRIOR_AUTH_SUCCESS:
                return {
                    ...state,
                    priorAuth: payload.data,
                    loading: false
                };
    
        case SET_PRIOR_AUTH_ERROR:
                return {
                    ...state,
                    priorAuth: {},
                    loading: false,
                    error: {...state.error , ['Error-' + payload.index]: true, ...payload.error}
                };
    
        case SET_PRIOR_AUTH_CLEANUP:
                return initialState;
                
            

        default:
            return state;
    }
};
